// Backend Service API calls
import axios from "axios";

let API_BASE_URL = import.meta.env.VITE_API_URL || "/api/v1";

// Main API client for backend services
export const apiClient = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access

      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export const propertyAPI = {
  // Property API calls
  getProperties: (params = {}) => {
    return apiClient.get("/properties/", { params });
  },
  createProperty: (propertyData) => {
    return apiClient.post("/properties/", propertyData);
  },
  deleteProperty: (id) => {
    return apiClient.delete(`/properties/${id}`);
  },
  updateProperty: (id, propertyData) => {
    return apiClient.put(`/properties/${id}`, propertyData);
  },
  readProperty: (id) => {
    return apiClient.get(`/properties/${id}`);
  },
  completeTenantChange: (id) => {
    return apiClient.post(`/properties/${id}/complete_tenant_change`);
  },
  importPropertiesFromXlsx: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post("/properties/import/xlsx", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
